import { darken, transparentize } from 'polished';
import { fontStack } from './utils';
// Constants
const SERIF = ['merriweather', 'Times New Roman', 'serif'];
const SANS_SERIF = [
    'aktiv-grotesk',
    'Helvetica',
    'Arial',
    'sans-serif',
    'Apple Color Emoji'
];
const TERRACOTTA = '#ef4631';
const SANDY_BROWN = '#f3a258';
const SHAKESPEARE = '#53bed0';
const SAN_MARINO = '#5267b4';
const GRAY_1 = '#3c3a3b';
const GRAY_2 = '#5f5d5e';
const GRAY_3 = '#858384';
const GRAY_4 = '#acaaab';
const GRAY_5 = '#d6d3d5';
const GRAY_6 = '#ededed';
export const ON_HOVER_DARKEN_ALPHA = 0.07;
export const ON_CLICK_DARKEN_ALPHA = 0.14;
export const ON_HOVER_TRANSPARENTIZE_ALPHA = 0.95;
export const ON_CLICK_TRANSPARENTIZE_ALPHA = 0.85;
export const colors = {
    brand: TERRACOTTA,
    terracotta: TERRACOTTA,
    sandybrown: SANDY_BROWN,
    shakespeare: SHAKESPEARE,
    sanmarino: SAN_MARINO,
    accent: [TERRACOTTA, SANDY_BROWN, SHAKESPEARE, SAN_MARINO],
    gray: [GRAY_1, GRAY_2, GRAY_3, GRAY_4, GRAY_5, GRAY_6]
};
const defaultButtonStyle = {
    color: {
        default: colors.brand,
        hover: 'white',
        active: 'white',
        disabled: 'white'
    },
    border: {
        default: colors.brand,
        hover: darken(ON_HOVER_DARKEN_ALPHA, `${colors.brand}`),
        active: darken(ON_CLICK_DARKEN_ALPHA, `${colors.brand}`),
        disabled: 'gray.2'
    },
    bg: {
        default: 'transparent',
        hover: darken(ON_HOVER_DARKEN_ALPHA, `${colors.brand}`),
        active: darken(ON_CLICK_DARKEN_ALPHA, `${colors.brand}`),
        disabled: 'gray.2'
    }
};
const buttons = {
    default: defaultButtonStyle,
    primary: {
        color: {
            default: 'white',
            hover: '',
            active: '',
            disabled: ''
        },
        border: {
            default: colors.brand,
            hover: darken(ON_HOVER_DARKEN_ALPHA, `${colors.brand}`),
            active: darken(ON_CLICK_DARKEN_ALPHA, `${colors.brand}`),
            disabled: 'gray.2'
        },
        bg: {
            default: colors.brand,
            hover: darken(ON_HOVER_DARKEN_ALPHA, `${colors.brand}`),
            active: darken(ON_CLICK_DARKEN_ALPHA, `${colors.brand}`),
            disabled: 'gray.2'
        }
    },
    secondary: defaultButtonStyle,
    tertiary: {
        color: {
            default: colors.brand,
            hover: colors.brand,
            active: colors.brand,
            disabled: 'white'
        },
        border: {
            default: 'transparent',
            hover: transparentize(ON_HOVER_TRANSPARENTIZE_ALPHA, `${colors.brand}`),
            active: transparentize(ON_CLICK_TRANSPARENTIZE_ALPHA, `${colors.brand}`),
            disabled: 'gray.2'
        },
        bg: {
            default: 'transparent',
            hover: transparentize(ON_HOVER_TRANSPARENTIZE_ALPHA, `${colors.brand}`),
            active: transparentize(ON_CLICK_TRANSPARENTIZE_ALPHA, `${colors.brand}`),
            disabled: 'gray.2'
        }
    }
};
const theme = {
    borderWidths: [0, '1px', '2px', '4px', '8px'],
    breakpoints: ['544px', '768px', '1366px'],
    buttons,
    colors,
    fonts: {
        h1: fontStack(SERIF),
        h2: fontStack(SERIF),
        h3: fontStack(SANS_SERIF),
        h4: fontStack(SERIF),
        h5: fontStack(SANS_SERIF),
        h6: fontStack(SANS_SERIF),
        body: fontStack(SANS_SERIF),
        sansSerif: fontStack(SANS_SERIF),
        serif: fontStack(SERIF)
    },
    fontWeights: {
        light: 300,
        normal: 400,
        bold: 700
    },
    fontSizes: ['16px', '20px', '22px', '28px', '32px', '40px'],
    lineHeights: {
        normal: '1.2',
        medium: '1.5'
    },
    radii: ['0', '2px', '4px', '8px'],
    shadows: [
        '0px 0px 10px rgba(0, 0, 0, 0.08)',
        '0px 0px 15px rgba(0, 0, 0, 0.16)',
        '0px 0px 20px rgba(0, 0, 0, 0.24)'
    ],
    space: [
        '0',
        '4px',
        '8px',
        '16px',
        '24px',
        '32px',
        '40px',
        '48px',
        '64px',
        '80px',
        '96px',
        '112px',
        '128px'
    ]
};
export default theme;
//# sourceMappingURL=theme.js.map